import React, { useState } from 'react';

// Comps
import AccountForm from '../AccountForm/AccountForm';
import AccountFormHeader from '@project-stories/ecommerce/Account/AccountFormHeader/AccountFormHeader';

type Props = {
    section: any;
    signUpFields: any;
    headerColorSchema?: string;
};

export const LoginAndRegister = ({ section, signUpFields, headerColorSchema }: Props) => {
    const {
        // Header
        title_type,
        title_type_mobile,
        body_type,
        body_type_mobile,

        // Login
        title_login,
        tagline_login,

        // Register
        title_register,
        tagline_register
    } = section;
    const titleType = `${title_type_mobile} ${title_type}-lg`;
    const taglineType = `${body_type_mobile} ${body_type}-lg`;

    // States
    const [showCustomFields, setShowCustomFields] = useState(true);

    return (
        <>
            {/* Login */}
            <div className='md:sticky top-[calc(var(--header-height)+1rem)]'>
                <AccountFormHeader
                    title={title_login}
                    titleType={titleType}
                    tagline={tagline_login}
                    taglineType={taglineType}
                    colorSchema={headerColorSchema}
                />

                <AccountForm
                    section={section}
                    isRegister={false}
                    showCustomFields={showCustomFields}
                />
            </div>

            {/* Register */}
            <div className='md:sticky top-[calc(var(--header-height)+1rem)]'>
                <AccountFormHeader
                    title={title_register}
                    titleType={titleType}
                    tagline={tagline_register}
                    taglineType={taglineType}
                    colorSchema={headerColorSchema}
                />

                <AccountForm
                    section={section}
                    isRegister={true}
                    showCustomFields={showCustomFields}
                    signUpFields={signUpFields}
                />
            </div>
        </>
    );
};

export default LoginAndRegister;